module.exports = __webpack_public_path__ + "img/guandai_yj_zhongxidi.91306098.jpg";